import { Component, OnInit, Input } from '@angular/core';
import {AchooInputComponent} from '../achoo-input/achoo-input.component';
import {ValidationHandlerService} from '../validation-handler.service';

@Component({
  selector: 'achoo-material-textarea',
  templateUrl: './achoo-material-textarea.component.html',
  styleUrls: ['./achoo-material-textarea.component.scss']
})
export class AchooMaterialTextareaComponent extends AchooInputComponent<any> {

  @Input()
  public numberCol: number;

  constructor(protected validationHandlerService: ValidationHandlerService) {
    super(validationHandlerService);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-material-textarea/achoo-material-textarea.component.ts